import {h, Component} from "preact";
import animate from "./animate";

import AwrabetAutomatedSlider from "../../awrabet/utils/auto-slider";

export default class AutomatedSlider extends AwrabetAutomatedSlider {
    render(props) {
        return <div class={"overflow-x-auto fn-scroll-container "+props.class} ref={el => this.scrollableDiv = el} onMouseEnter={() => this.hasMouseOver = true} onMouseLeave={() => this.hasMouseOver = false}>
			{this.props.children}
		</div>;
    }
}
